import { render } from "./BoxHistoricSearch.vue?vue&type=template&id=2259280e&scoped=true"
import script from "./BoxHistoricSearch.vue?vue&type=script&lang=js"
export * from "./BoxHistoricSearch.vue?vue&type=script&lang=js"

import "./BoxHistoricSearch.vue?vue&type=style&index=0&id=2259280e&lang=css"
import "./BoxHistoricSearch.vue?vue&type=style&index=1&id=2259280e&scoped=true&lang=css"

import exportComponent from "C:\\docker\\bene_piscinas_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2259280e"]])

export default __exports__